export default function HeroSection() {
  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Abstract%20minimalist%20geometric%20composition%20with%20flowing%20organic%20shapes%20in%20warm%20cream%20beige%20and%20soft%20terracotta%20tones%2C%20gentle%20gradient%20transitions%2C%20subtle%20digital%20texture%2C%20clean%20modern%20aesthetic%2C%20no%20people%20no%20text%2C%20architectural%20abstract%20background%2C%20warm%20earth%20color%20palette%2C%20high%20quality%20digital%20art%2C%20serene%20calm%20atmosphere&width=1800&height=1200&seq=apade-hero-bg-01&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/35" />

      <div className="relative z-10 w-full max-w-5xl mx-auto px-4 md:px-6 py-20 md:py-28 text-center">
        <div className="animate-fade-in opacity-0 [animation-fill-mode:forwards]">
          <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full bg-background-50/20 backdrop-blur-sm mb-8 md:mb-10">
            <div className="w-2 h-2 rounded-full bg-accent-400" />
            <span className="text-xs md:text-sm font-medium tracking-widest uppercase" style={{ fontFamily: 'var(--font-label)', color: 'oklch(var(--background-50))' }}>
              Professional Engineering
            </span>
          </div>
        </div>

        <h1
          className="animate-fade-in-up opacity-0 [animation-fill-mode:forwards] animation-delay-200 text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-heading font-semibold leading-tight tracking-tight mb-6 md:mb-8"
          style={{ color: 'oklch(var(--background-50))' }}
        >
          (Apade Solutions OU)
        </h1>

        <p
          className="animate-fade-in-up opacity-0 [animation-fill-mode:forwards] animation-delay-400 text-base sm:text-lg md:text-xl max-w-2xl mx-auto leading-relaxed"
          style={{ color: 'oklch(var(--background-100) / 0.85)' }}
        >
          Designing and developing modern digital software solutions for the iOS platform and related technologies
        </p>

        <div
          className="animate-fade-in-up opacity-0 [animation-fill-mode:forwards] animation-delay-600 mt-12 md:mt-16 inline-flex items-center gap-2 px-6 py-3 rounded-lg"
          style={{ backgroundColor: 'oklch(var(--background-50) / 0.1)', backdropFilter: 'blur(4px)' }}
        >
          <span className="text-sm font-medium tracking-wide" style={{ fontFamily: 'var(--font-label)', color: 'oklch(var(--background-100))' }}>
            Scalable &middot; Maintainable &middot; High-Performance
          </span>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-fade-in opacity-0 [animation-fill-mode:forwards] animation-delay-800">
        <div className="w-5 h-8 rounded-full border-2 flex items-start justify-center pt-1.5" style={{ borderColor: 'oklch(var(--background-50) / 0.4)' }}>
          <div className="w-1 h-1.5 rounded-full animate-bounce" style={{ backgroundColor: 'oklch(var(--background-50) / 0.7)' }} />
        </div>
      </div>
    </section>
  );
}